import { useEffect } from "react";

export const useGlobalSearch = (onSearchCallback) => {
    const { dataFromManualSearch } = location.state || {};

    useEffect(() => {
        if (dataFromManualSearch) {
            //Logica para aplicar un filtro de id con lo que venga en dataFromManualSearch
            onSearchCallback?.(dataFromManualSearch);
            location.state = {};
        } else {
            //limpiar ese filtro
        }
    }, [dataFromManualSearch]);
}